export const HomeContainer = [
    {title:'Top Ten Dentists',path:'/dentists'},
    {title:'Top Ten Lawyers',path:'/lawyers'},
    {title:'Top Ten Realtors',path:'/realtors'},
    {title:'Top Ten Physiotherapists',path:'/physiotherapists'},
    {title:'Top Ten General Physicians',path:'/generalPhysicians'},
    {title:'Top Ten Saloon & Spa',path:'/saloons'},
    {title:'Top Ten Accountants',path:'/accountants'},
    {title:'Top Ten Immigration agents',path:'/immigration'},
    {title:'Top Ten Insurance agents',path:'/insuranceAgents'},
    {title:'Top Ten Optimetrist',path:'/optimetrists'}
]